import PerfectScrollbar from 'perfect-scrollbar';
import { Loader } from './loader';
import { Routing, Menu, Popup } from './routing';
import { Portfolio } from './portfolio';
import { Form } from './form';

Routing.init();
Portfolio.init();
Loader.init();
Menu.init();
Popup.init();
Form.init();
new PerfectScrollbar('#app', {
  suppressScrollX: true
});
